import PropTypes from 'prop-types';
import React from 'react';
// -*- mode: jsx;-*-
import { HomeProjectSection } from '../common/HomeProjectSection.js';

let EquityFocusProjectsSection = function (props) {
    const url = props.baseSearchURL + '?equityFocus=true&max=25&hasPhoto=true';

    return (
        <HomeProjectSection searchURL={url} title="Equity Focus School Projects"
            projects={props.getProjects(url)} loadProjects={props.loadProjects}
            className="projects-equity-focus"
            description="Help address inequity by supporting our Equity Focus Schools">
        </HomeProjectSection>
    );
};

EquityFocusProjectsSection.propTypes = {
    baseSearchURL: PropTypes.string.isRequired,
    loadProjects: PropTypes.func.isRequired,
    getProjects: PropTypes.func.isRequired,
    detectedLocation: PropTypes.object,
};
EquityFocusProjectsSection = React.memo(EquityFocusProjectsSection);
export default EquityFocusProjectsSection;
